import _ from 'lodash';

// urls2html takes a string in and replaces any recognized URLs with an
// anchor tag that links to the URL. Optionally, a target value can
// replace the default _self value of the target attribute.
export function urls2html(value, target) {
  const targetLocal = target || '_self';
  /* eslint-disable-next-line */
  const regex = /(\s|^)((?:\w+:\/\/)?(?:\w*[a-zA-Z]\w*\.)?\w*[a-zA-Z]\w*\.[a-zA-Z]\/?[-%\/\w\.\?&=#]*)/g
  const anchor = `$1<a href="http://$2" target="${targetLocal}" `
    + 'rel="noopener noreferrer">$2</a>';
  const html = value.replace(regex, anchor);
  const htmlCleaned = html.replace(/http:\/\/http/g, 'http');
  return htmlCleaned;
}

// stripHTMLTags removes any <blah> tags from a string.
export function stripHTMLTags(str) {
  if (!str) return '';
  return str.replace(/<[^>]*>?/gm, '');
}

// Splits a string like python when limited by returning the rest
// of the unsplit string at the end.
export function pythonSplit(str, sep, limit) {
  const fullSplit = str.split(sep);
  const result = fullSplit.slice(0, limit);
  if (limit < fullSplit.length) {
    result.push(fullSplit.slice(limit).join(sep));
  }
  return result;
}

export function dedupeVerb(name) {
  /*
    Removes the first word of a string if it's the same as the second word.
    Performs case-insensitive comparison of the first two words.
    Returns the modified string with one instance of the duplicate removed,
    or the original string if no duplicate is found.

    @param {string} name - The input string to check for duplicate first
    words
    @return {string} - String with duplicate first word removed or original
    if no duplicate
  */
  const words = _.words(name);

  if (words.length < 2) {
    return name;
  }

  if (_.toLower(words[0]) === _.toLower(words[1])) {
    return _.join(words.slice(1), ' ');
  }

  return name;
}
